import React from "react";

import { Box, Link, Truncate } from "@catchoftheday/cg-components";

import { BrandType } from "../productCardTypes";

type ProductCardBrandProps = {
  brand?: BrandType;
};

export const ProductCardBrand: React.FC<ProductCardBrandProps> = ({
  brand,
}) => {
  function renderContent() {
    if (!brand) {
      return <>&nbsp;</>;
    }

    const { name, slug } = brand;
    return (
      <Link
        textDecoration="underline"
        color="typography.subText"
        href={`/brand/${slug}`}
      >
        {name}
      </Link>
    );
  }

  return (
    <Box
      data-testid="product-brand"
      fontSize="xs"
      fontWeight="light"
      color="typography.subText"
      display="block"
      px="10px"
      mb="6px"
      position="relative"
    >
      <Truncate>{renderContent()}</Truncate>
    </Box>
  );
};
